import { Page } from '../../../../components/Page/Page';
import { SubjectGroupTable } from '../../../../components/SubjectGroup/Tables/SubjectGroupTable';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const TimetableSubjectGroupsSubpage = () => {
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadTimetable()}>
      <SubjectGroupTable />
    </Page>
  );
};
